import React from 'react';

import { DownstreamOwnerIdsFilteredByFieldQuery, DownstreamOwnerIdsFilteredByFieldQueryVariables, OwnerIdFragment, VirtualConnectionTableDownstreamOwnerIdsQuery, VirtualConnectionTableDownstreamOwnerIdsQueryVariables , DownstreamOwnerIdsFilteredByFieldDocument , VirtualConnectionTableDownstreamOwnerIdsDocument } from '../../../../../gen-src/queries';
import {
  ComposeEmailPaneButton,
  DataCatalogApolloClient,
  getAllFromSliceable,
  GraphQLSliceable,
  HorizontalFlexContainer,
  MultiSelectionProvider,
  PaneTitle,
  Sliceable,
  VerticalFlexContainer
} from '../../../data-catalog-shared';
import { OwnersGridSortProvider } from '../sorting/sortProviders/OwnersGridSortProvider';
import { MultiSelectionControls } from '../widgets/MultiSelectionControls';
import { VirtualConnectionTableDownstreamOwnersQueryGrid } from './VirtualConnectionTableDownstreamOwnersQueryGrid';

export interface VirtualConnectionTableDownstreamOwnersPaneProps {
  readonly title: string;
  readonly vizportalUrlId: string;
  readonly filteredColumnId: string | null;
  readonly rowCount: number | null;
  readonly virtualConnectionTableLuid: string;
}

export class VirtualConnectionTableDownstreamOwnersPane extends React.Component<VirtualConnectionTableDownstreamOwnersPaneProps> {

  public override render(): JSX.Element {
    return (
      <MultiSelectionProvider selectionId={this.props.vizportalUrlId}>
        {({ selectedKeys, setSelectedKeys, updateSelectionForKey }) =>
          <VerticalFlexContainer fillFlexParent={true}>
            <PaneTitle>
              <HorizontalFlexContainer>
                {this.props.title}
                {this.props.rowCount != null && this.props.rowCount > 0 ?
                  <>
                    <MultiSelectionControls
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      updateSelectionForKey={updateSelectionForKey}
                      fetchAllKeys={this.fetchAllOwnerKeys}
                    />
                    <ComposeEmailPaneButton
                      selectedUserIds={selectedKeys}
                      contentType='virtualConnectionTable'
                      contentId={this.props.vizportalUrlId}
                      contentLuid={this.props.virtualConnectionTableLuid}
                    />
                  </>
                  : null
                }
              </HorizontalFlexContainer>
            </PaneTitle>
            <OwnersGridSortProvider>
              {({ orderBy, updateSortOrder }) =>
                <VirtualConnectionTableDownstreamOwnersQueryGrid
                  vizportalUrlId={this.props.vizportalUrlId}
                  selectedKeys={selectedKeys}
                  updateSelectionForKey={updateSelectionForKey}
                  filteredColumnId={this.props.filteredColumnId}
                  rowCount={this.props.rowCount}
                  orderBy={orderBy}
                  updateSortOrder={updateSortOrder}
                />
              }
            </OwnersGridSortProvider>
          </VerticalFlexContainer>
        }
      </MultiSelectionProvider>
    );
  }

  private readonly fetchAllOwnerKeys = async (client: DataCatalogApolloClient): Promise<ReadonlyArray<string>> => {
    const sliceable = this.createOwnerIdsSliceable(client);
    const items = await getAllFromSliceable(sliceable);
    return items.map(item => item.vizportalId);
  }

  private createOwnerIdsSliceable(client: DataCatalogApolloClient): Sliceable<OwnerIdFragment> {
    if (this.props.filteredColumnId) {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        DownstreamOwnerIdsFilteredByFieldQueryVariables,
        DownstreamOwnerIdsFilteredByFieldQuery
      >({
        queryGql: DownstreamOwnerIdsFilteredByFieldDocument,
        selectConnectionListResult: (resultData) => {
          const field = resultData.fields && resultData.fields[0];
          return field.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { fieldId: this.props.filteredColumnId }, client);
    } else {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        VirtualConnectionTableDownstreamOwnerIdsQueryVariables,
        VirtualConnectionTableDownstreamOwnerIdsQuery
      >({
        queryGql: VirtualConnectionTableDownstreamOwnerIdsDocument,
        selectConnectionListResult: (resultData) => {
          const virtualConnectionTable = resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
          return virtualConnectionTable.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { vizportalUrlId: this.props.vizportalUrlId }, client);
    }
  }

}
